import moment from 'moment';
import { Row } from 'react-table';
import { useFormatMoment } from 'app/hooks/useFormatMoment';
import { Icon, NotificationsActionCell } from "app/components";

import styles from './NotificationsPage.module.scss';
import { Notification } from 'ais-facade-api/api';

export const columns = [
  {
    Header: 'Date',
    accessor: 'date',
    Cell: ({ row: { original: notification } }: { row: Row<Notification> }) => {
      const formatMoment = useFormatMoment();
      return <>{notification.dt ? formatMoment(moment(notification.dt)) : <>&mdash;</>}</>;
    },
  },
  {
    Header: 'Notification',
    accessor: 'notification',
    Cell: ({ row: { original: notification } }: { row: Row<Notification> }) => {
      return <>{notification.message ? notification.message : <>&mdash;</>}</>;
    },
  },
  {
    Header: <Icon name="more-icon" width="13px" height="3px" />,
    accessor: 'actionCell',
    width: 34,
    minWidth: 34,
    maxWidth: 34,
    disableSortBy: true,
    Cell: ({ row: { original: notification } }: { row: Row<Notification> }) => (
      <>
        <div className={styles.action_cell}>
          <NotificationsActionCell notification={notification} />
        </div>

      </>
    ),
  },
];
